import { Box } from "@mui/material";
import Chip from '@mui/material/Chip';
import BackupIcon from '@mui/icons-material/Backup';
import { useDropzone } from 'react-dropzone';

const DropzoneArea = (props) => {
  const {acceptedFiles, getRootProps, getInputProps} = useDropzone(
    {
      accept: {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      },
      maxFiles:1,
      onDrop: props.onChange
    }
  );

  const filename = acceptedFiles.map(file => (
      file.path
  ));


  return (
    <div className="container">
      <Box {...getRootProps({className: 'dropzone'})} sx={{textAlign: 'center', border: '3px dashed #dddddd'}}>
        <input {...getInputProps()} />
        <Box sx={{ fontSize: '16px', marginTop: '24px', marginBottom: '24px' }}>{props.dropzoneText}</Box>
        <BackupIcon  sx={{ fontSize: '51px' }} />
      </Box>
      {!props.disabled &&
      <Box>
        <Box sx={{ fontSize: '16px' }}>Selected file</Box>
        <Chip

          label={props.selectedFilename}
          variant="outlined"
          //onClick={handleClick}
          //onDelete={handleDelete}
        />
      </Box>}
    </div >
  );
};

export { DropzoneArea };